
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"32","height":"32","rx":"16","fill":"#F6F9FC"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.003 8.9798C20.3284 8.65436 20.8561 8.65436 21.1815 8.9798L22.7621 10.5604C23.0875 10.8858 23.0875 11.4134 22.7621 11.7389L12.9459 21.5551C12.8242 21.6767 12.668 21.7577 12.4985 21.787L10.5878 22.1171C10.0203 22.2151 9.52676 21.7216 9.6248 21.154L9.95487 19.2434C9.98415 19.0739 10.0652 18.9176 10.1868 18.796L20.003 8.9798ZM20.5922 10.2762L19.6281 11.2403L20.5016 12.1138L21.4657 11.1496L20.5922 10.2762ZM11.2417 19.6266L18.6853 12.1831L19.5587 13.0566L12.1152 20.5001L11.0593 20.6825L11.2417 19.6266ZM16.6668 20.6667C16.2986 20.6667 16.0001 20.9652 16.0001 21.3334C16.0001 21.7015 16.2986 22 16.6668 22H22.0001C22.3683 22 22.6668 21.7015 22.6668 21.3334C22.6668 20.9652 22.3683 20.6667 22.0001 20.6667H16.6668Z","fill":"#7344C0"}})])
          )
        }
      }
    